import React, { useState } from 'react';
import axios from '../../../library/axios';
import { MySwal } from '../../../library/swal';
import Button from 'react-bootstrap/Button';
import { getApiErrorMessage } from '../../../helpers/apiErrorMessage';

const CreateRiskDivisionComp = (props) => {
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [namaDivision, setnamaDivision] = useState('');

  const handleCreateDivision = () => {
    setLoading(true);
    setDisabled(true);

    const requestBody = {
      namaDivision: namaDivision,
    };
    // console.log(requestBody)
    // return false
    axios({
      url: '/risk-divisions/create',
      method: 'POST',
      data: requestBody,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
      .then((res) => {
        // console.log(res)
        // return false
        if (res.status === 200) {
          MySwal.fire({
            icon: 'success',
            title: 'Success',
            text: 'Successfully tambah divisi!',
          });

          setLoading(false);
          setDisabled(false);

          props.close();
          props.fetch();
        }
      })
      .catch((err) => {
        setLoading(false);
        setDisabled(false);
        if (err !== '') {
          console.log(err?.response?.data?.message);
          MySwal.fire({
            icon: 'error',
            title: 'Oops, Error!',
            text: getApiErrorMessage(err),
          });
        }
      });
  };

  return (
    <div>
      <div className="mb-3 row">
        <label htmlFor="namaDivision" className="col-sm-4 col-form-label">
          Unit Kerja
        </label>
        <div className="col-sm-12">
          <input
            type="text"
            className="form-control"
            id="namaDivision"
            onChange={(e) => setnamaDivision(e.target.value)}
            value={namaDivision}
          />
        </div>
      </div>

      <div className="mt-8 row">
        <div className="col-12">
          <Button variant="danger" size="sm" onClick={() => props.close()}>
            Tutup
          </Button>
          &nbsp;
          <Button
            disabled={disabled}
            variant="success"
            size="sm"
            onClick={() => handleCreateDivision()}
          >
            {loading === true ? 'Mohon Tunggu..' : 'Simpan'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CreateRiskDivisionComp;
